module.exports = __webpack_public_path__ + "static/media/VisbyCF-Medium.7520b953.woff";